import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [
    "monthly",
    "annual",
    "monthlyPrice",
    "annualPrice",
    "monthlyPeriod",
    "annualPeriod",
    "proForm",
    "eliteForm"
  ]

  connect() {
    this.monthly()
  }

  monthly() {
    this.monthlyPriceTargets.forEach(element => element.classList.remove("hidden"))
    this.annualPriceTargets.forEach(element => element.classList.add("hidden"))

    this.monthlyPeriodTargets.forEach(element => element.classList.remove("hidden"))
    this.annualPeriodTargets.forEach(element => element.classList.add("hidden"))

    this.updatePlanButtons("monthly")
    this.activate(this.monthlyTarget, this.annualTarget)
  }

  annual() {
    this.monthlyPriceTargets.forEach(element => element.classList.add("hidden"))
    this.annualPriceTargets.forEach(element => element.classList.remove("hidden"))

    this.monthlyPeriodTargets.forEach(element => element.classList.add("hidden"))
    this.annualPeriodTargets.forEach(element => element.classList.remove("hidden"))

    this.updatePlanButtons("annual")
    this.activate(this.annualTarget, this.monthlyTarget)
  }

  updatePlanButtons(period) {
    this.updatePlanButton(this.proFormTarget, period)
    this.updatePlanButton(this.eliteFormTarget, period)
  }

  updatePlanButton(form, period) {
    form.querySelector('input[name="subscription[plan_id]"]').value =
      form.dataset[`${period}PlanId`]
  }

  activate(active, inactive) {
    active.classList.add("bg-gray-100", "text-gray-900")
    active.classList.remove("text-gray-500")

    inactive.classList.remove("bg-gray-100", "text-gray-900")
    inactive.classList.add("text-gray-500")
  }
}
